import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { InstitutiiSettingsComponent } from './institutii-settings/institutii-settings.component';
import { DocumentePubliceModule } from './documente-publice/documente-publice.module';
import { AniModule } from './institutii-settings/ani/ani.module';
import { CategoriiDocumenteModule } from './institutii-settings/categorii-documente/categorii-documente.module';
import { TipuriDocumenteModule } from './institutii-settings/tipuri-documente/tipuri-documente.module';
import { SectiuniPubliceModule } from './institutii-settings/sectiuni-publice/sectiuni-publice.module';
import { OperatoriInstitutiiModule } from './operatori-institutii/operatori-institutii.module';

@NgModule({
    declarations: [
        InstitutiiSettingsComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        DocumentePubliceModule,
        AniModule,
        CategoriiDocumenteModule,
        TipuriDocumenteModule,
        SectiuniPubliceModule,
        OperatoriInstitutiiModule,
    ],
    exports: [InstitutiiSettingsComponent]
})
export class InstitutiiModule { }
